import { observable, action, makeObservable, runInAction } from 'mobx';
import { getInviteInfo, getConfigInfo, submitInviteInfo, improveInfoDetail, submitImproveInfo } from '@/api/student_invite';
import message from '@/components/Toast';

class InvitePerfectInfo {
  constructor() {
    makeObservable(this);
  }

  @observable
  auth_token = '';

  @action
  setAuthToken(token) {
    this.auth_token = token;
  }

  @observable
  invite_flag = false;

  @action
  setInviteFlag(result) {
    this.invite_flag = result;
  }

  @observable
  invite_info = {};

  @action
  setInviteInfo(info) {
    this.invite_info = info;
  }

  getInviteInfo = async (id, tenantId) => {
    const { data, msg, code } = await getInviteInfo(id, {
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      this.setInviteInfo(data);
    } else if (code === 'A1111') {
      this.setInviteInfo({ invitation_status: 'A1111' });
    } else {
      this.setInviteInfo({});
      message.error(msg);
    }
  };

  @observable
  config_info = {};

  @action
  setConfigInfo(info) {
    this.config_info = info;
  }

  getConfigInfo = async (id,tenantId) => {
    const { data, msg, code } = await getConfigInfo(id,{
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      this.setConfigInfo(data);
      this.setAuthToken(data['verify_token']);
    } else if (code === 'A1806') {
      this.setConfigInfo({});
      return null;
    } else {
      this.setConfigInfo({});
      message.error(msg);
    }
  };
  bindAccount = async (params, tenantId) => {
    const { msg, code, data } = await submitInviteInfo(params, {
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      if (this.config_info.improve_config && this.config_info.improve_config.length) {
        this.setAuthToken(data);
        const result = await this.improveInfoDetail({ auth_token: data }, tenantId);
        return result;
      }
      this.setInviteFlag(true);
      runInAction(() => {
        this.invite_info.phone_number = params.mobile;
      });
      return false;
    }
    message.error(msg);
    return false;
  };

  @observable
  improve_info = {};

  @action
  setImproveInfo(info) {
    this.improve_info = info;
  }

  improveInfoDetail = async (form, tenantId) => {
    const { msg, code, data } = await improveInfoDetail(form, {
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      this.setImproveInfo(data);
      return data;
    }
    return message.error(msg);
  };

  @observable
  isLoading = false;

  @action
  setIsLoading(result) {
    this.isLoading = result;
  }

  submitImproveInfo = async (form, tenantId) => {
    this.setIsLoading(true);
    const { msg, code, data } = await submitImproveInfo(form, {
      headers: {
        TenantId: tenantId
      }
    });
    if (code === '00000') {
      runInAction(() => {
        this.invite_flag = true;
        this.invite_info.identity_name = data['name'];
        this.invite_info.phone_number = data['mobile'];
      });
      this.setIsLoading(false);
    } else {
      this.setIsLoading(false);
      return message.error(msg);
    }
  };
}
const invitePerfectInfo = new InvitePerfectInfo();
export default invitePerfectInfo;
